import { Exit } from "slotworks/state-machine/data/exit";
abstract class Decision {

    /**
     * Called when this decision is queried.
     *
     * @return {Exit}
     */
    public evaluate(): Exit {
        return Exit.True;
    }
}

export default Decision;
